import { Table } from "react-bootstrap";
import { PageLoader } from "../../../../Components/NoDataFoundTable/NoDataFoundTable";

const SitePerformanceSummaryData = ({ sitePerformanceLoader, sitePerformance = [] }) => {
  return (
    <>
      <h6 className="fw-bold mb-2">Site Performance Summary</h6>
      {sitePerformanceLoader ?
        <div
          className="hstack justify-content-center"
          style={{ height: "calc(100vh - 500px)" }}
        >
          <PageLoader/>
        </div>
        :
         <Table className="m-0 custom-table" hover striped>
            <thead className="position-sticky top-0 z-1">
            <tr>
              <th className="text-center" style={{ width: 45 }}>
                Sr.
              </th>
              <th>Site</th>
              <th>Total Notifications</th>
              <th>Avg. Time to Close</th>
              <th>% Closed {`<`} 7 Days</th>
              <th>Overdue Notifications</th>
            </tr>
          </thead>
          <tbody>
            {sitePerformance?.map((item, index) => (
              <tr key={index}>
                <td className="text-center">{index+1}</td>
                <td>{item?.siteName}</td>
                <td>{item?.totalNotification}</td>
                <td>{item?.avarangeTimeClose}</td>
                <td>{item?.closed7Days}</td>
                <td>{item?.overdueNotification}</td>
              </tr>
            ))}
          </tbody>
        </Table>
      }
    </>
  );
};

export default SitePerformanceSummaryData;
